export enum ScheduledSurveyResultsPageSection {
  CollaboratorsFeedback = "collaborators-feedback",
  QuestionPrefix = "question-",
}
